<template>
  <div>
    <div v-wechat-title="'《提灯与地下城》海灵主宰·龙拳破天'"></div>
    <div class="pc-page">
      <div class="logo"></div>
      <div class="banner"></div>
      <div class="qrcode-box"></div>
    </div>
  </div>

</template>
<script>
import { getTimeStamp, buriedLogger } from '@/utils/utils';
import { mapActions } from 'vuex';
export default {
  components: {},
  data() {
    return {
      enterLink: '',
    };
  },
  created() {
    const bl = buriedLogger("tideng", "五周年庆_PC端");
    this.logger = bl;
  },
  mounted() {
    this.$nextTick(() => {
      // 分享
      this.enterLink = 'https://h5.qingcigame.com/tideng/recall/anniversary';
      this.monitoringEquipment(this.enterLink);
      this.isSetShare(this.enterLink);
    });
  },
  computed: {},
  methods: {
    monitoringEquipment(linkUrl) {
      if (navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) {
        location.href = `${linkUrl}${getTimeStamp()}`
      }
    },
    // 微信分享
    isSetShare(linkUrl) {
      this.setShare({
        link: linkUrl + `${getTimeStamp()}`,
        title: "《提灯与地下城》新版本上线",
        imgUrl: 'https://download4.qcplay.com/qcgame-api/9VHWniV91Q3sfOtCISCEmR9aWVEaAj7jLqrT2VKZ.png',
        desc: "《提灯与地下城》组队积分活动，可获得史诗级头衔：海灵主宰·龙拳破天、10星装备升星券、钻石*1000等丰厚奖励，集结归来的灯友，就差你了！",
      })
    },
    ...mapActions(["setShare"])
  }
};
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/tideng/recall/pc/index.vue